import FieldNames from "../../../aiim/datasets/FieldNames";
import * as aiimUtil from "../../../aiim/util/aiimUtil";
import * as sourceUtil from "../sourceUtil";
import * as transaction from "./transaction";
import {
  addAttributeEdit,
  appendUnitUnassignment,
  clonePersonFeature,
  cloneUnitFeature,
  fetchRelatedPeople,
  makeUnassignPeopleUpdates
} from "./transactionUtil";

/*
  transactions

    assignUnitsToArea
    unassignUnits

*/

export function prepare(task) {
  const promise = new Promise((resolve,reject) => {

    const transactionInfo = transaction.makeTransactionInfo();
    const unitFeatureItems = task.unitFeatureItems;
    const unitIds = [];
    let relatedPeopleInfo;

    unitFeatureItems.forEach(featureItem => {
      const unitId = aiimUtil.getAttributeValue(featureItem.feature.attributes,FieldNames.UNIT_ID);
      if (typeof unitId === "string" && unitId.length > 0) {
        unitIds.push(unitId);
      }
    });

    const makePeopleEdits = () => {
      let updates = [], undos = [];
      const layer = sourceUtil.getPeopleSource().layer2D;
      const keyField = layer.globalIdField;
      const keys = (relatedPeopleInfo && relatedPeopleInfo.globalIds);
      const features = (relatedPeopleInfo && relatedPeopleInfo.features) || [];

      if (task.assignUnitsToArea || task.unassignUnits) {
        updates = makeUnassignPeopleUpdates(task,keys,keyField);
      }
      if (updates.length > 0) {
        features.forEach(feature => {
          undos.push(clonePersonFeature(task,feature,"ensure-geometry"));
        });
      }

      if (updates.length > 0) {
        transactionInfo.peopleEdits = {updates: updates};
        transactionInfo.undo.peopleEdits = {updates: undos};
        transactionInfo.edits.push({
          id: layer.layerId,
          updates: updates
        });
        transactionInfo.undo.edits.push({
          id: layer.layerId,
          updates: undos
        });
      }
    };

    const makeUnitEdits = () => {
      const updates = [], undos = [];
      const layer = sourceUtil.getUnitsSource().layer2D;
      const fields = layer.fields;
      const keyField = layer.globalIdField;

      unitFeatureItems.forEach(featureItem => {
        undos.push(cloneUnitFeature(task,featureItem.feature,"no-geometry"));

        const update = {attributes: {}};
        update.attributes[keyField] = featureItem.feature.attributes[keyField];

        if (task.assignUnitsToArea) {
          const areaItem = task.assignUnitsToArea.areaItem;
          const areaType = task.assignUnitsToArea.areaType;
          const areaId = aiimUtil.getAttributeValue(areaItem.attributes,FieldNames.AREA_ID);
          addAttributeEdit(fields,update.attributes,FieldNames.UNITS_AREA_ID,areaId);
          addAttributeEdit(fields,update.attributes,FieldNames.UNITS_SPACE_ASSIGNMENT_TYPE,areaType);
          addAttributeEdit(fields,update.attributes,FieldNames.UTILIZATION, 0)
        }

        if (task.unassignUnits) {
          appendUnitUnassignment(task,fields,update);
        }

        updates.push(update);
      });

      if (updates.length > 0) {
        transactionInfo.unitEdits = {updates: updates};
        transactionInfo.undo.unitEdits = {updates: undos};
        transactionInfo.edits.push({
          id: layer.layerId,
          updates: updates
        });
        transactionInfo.undo.edits.push({
          id: layer.layerId,
          updates: undos
        });
      }
    };

    Promise.resolve().then(() => {
      if (task.assignUnitsToArea || task.unassignUnits) {
        return fetchRelatedPeople(task,unitIds).then(result => {
          relatedPeopleInfo = result;
          makePeopleEdits();
        });
      }
    }).then(() => {
      makeUnitEdits();
    }).then(() => {
      resolve(transactionInfo);
    }).catch(ex => {
      reject(ex);
    });

  });
  return promise;
}
